/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { OfficeUserListBusinessService } from './resources/office-user-list-business.service';
import { OfficeUserListComponent } from './components/office-user-list/office-user-list.component';

const routes = [
  createRoute({
    component: OfficeUserListComponent,
    path: '',
    init: OfficeUserListBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupOfficeUsersRoutingModule {
}
